export interface IMenuItem {
  id: string;
  title?: string;
  icon?: string;
  label?: string;
  showInTopNav?: boolean;
  topNavSequence?: number;
  topNavIcon?: string;
  bgColor?: string;
  itemClass?: string;
  to: string;
  sequence?: number;
  newWindow?: boolean;
  subs?: IMenuItem[];
  /** Billing Subscription Access*/
  billingProductId?: number;
  minimumSubscriptionName?: string;
}

export interface IMenuItemParent {
  id: number;
  parentId?: number;
  path?: string;
  depth?: number;
  label?: string;
}
